import { FC } from 'react';
import BlockContent from '@sanity/block-content-to-react';
import { getClient } from '../lib/sanity.server';
import React from 'react';
import { WistiaEmbed } from './WistiaEmbed';
import styles from './SanityBody.module.css';

interface Props {
  body: string;
}

interface VideoNode {
  assetId: string;
}

const VideoSerializer: FC<{ node: VideoNode }> = props => {
  return (
    <div className='mb-10'>
      <WistiaEmbed assetId={props.node.assetId} />
    </div>
  );
};

const ListSerializer: FC = props => {
  return <ul className='pseudo-markers'>{props.children}</ul>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ImageSerializer: FC = (props: any) => {
  return <div className='mt-4'>{BlockContent.defaultSerializers.types.image(props)}</div>;
};

const SanityBody: FC<Props> = ({ body }) => {
  return (
    <div className={`mt-16 body-paragraph leading-loose ${styles.prose}`}>
      <BlockContent
        blocks={body}
        imageOptions={{ w: 320, h: 240, fit: 'max' }}
        serializers={{
          types: { image: ImageSerializer, video: VideoSerializer },
          list: ListSerializer,
        }}
        {...getClient().config()}
      />
    </div>
  );
};

export default SanityBody;
